module.exports = __webpack_public_path__ + "img/9类电池.99e1deb5.webp";